import { render, staticRenderFns } from "./AllAttachementFileModal.vue?vue&type=template&id=bcc0fcfe&scoped=true&"
import script from "./AllAttachementFileModal.vue?vue&type=script&lang=js&"
export * from "./AllAttachementFileModal.vue?vue&type=script&lang=js&"
import style0 from "./AllAttachementFileModal.vue?vue&type=style&index=0&id=bcc0fcfe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcc0fcfe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bcc0fcfe')) {
      api.createRecord('bcc0fcfe', component.options)
    } else {
      api.reload('bcc0fcfe', component.options)
    }
    module.hot.accept("./AllAttachementFileModal.vue?vue&type=template&id=bcc0fcfe&scoped=true&", function () {
      api.rerender('bcc0fcfe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Waste/fileModal/AllAttachementFileModal.vue"
export default component.exports